// @ts-nocheck
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import {useRouter} from 'next/router';
import Breadcrumbs from '@/components/breadcrumbs';
import QueryHistory from '@/components/query/history';
import Fetch from '@/utils/Fetch';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import BillingService from '@/services/billing-service';
import SubscriptionContext from '@/utils/subscription-context';
import QueryForm from "@/PageComponents/Query/QueryForm";
import {Box, Flex} from "@mantine/core";
import {useMediaQuery} from "@mantine/hooks";
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function CreateQuery() {

  const router = useRouter()
  const { module: moduleParam, moduleID, customerID } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch
  const module = isNaN(parseInt((moduleParam as any))) ? null : parseInt((moduleParam as any));

  const { data: jobData } = useQuery(
    ['jobForQuery', moduleID],
    () => Fetch.get({ url: `/Job/${moduleID}` }),
    { enabled: module === Enums.Module.JobCard && !!moduleID }
  );

  const job = useMemo(() => jobData ?? {}, [jobData]);

  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = async () => {
    const [subscriptionInfo] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);

  const [selectedCustomer, setSelectedCustomer] = useState<any>();
  const [selectedCustomerName, setCustomerName] = useState('');

  const [selectedCustomerQueries, setCustomerQueries] = useState<any[]>([]);
  const [customerQueriesPage, setCustomerQueriesPage] = useState(0);
  const [querySearching, setQuerySearching] = useState(false);
  const [canLoadMoreQueries, setCanLoadMoreQueries] = useState(true);

  const [formIsDirty, setFormIsDirty] = useState(false);

  async function getCustomerQueries(currentQueries: any, page: any) {
    if (selectedCustomer?.ID) {
      setQuerySearching(true);
      const queries = await Fetch.get({
        url: `/Query?customerID=${selectedCustomer.ID}&includeClosed=True&pageSize=5&pageIndex=${page}`
      });

      let newQueries = [];
      newQueries.push(...currentQueries);
      newQueries.push(...queries.Results);
      setCustomerQueries(newQueries);
      setQuerySearching(false);

      if (queries.ReturnedResults < 5) {
        setCanLoadMoreQueries(false);
      } else if (newQueries.length == queries.TotalResults) {
        setCanLoadMoreQueries(false);
      }
    }
  }

  function loadMoreQueries() {
    setCustomerQueriesPage(customerQueriesPage + 1);
    getCustomerQueries(selectedCustomerQueries, customerQueriesPage + 1);
  }

  const firstCustomerUpdate = useRef(true);

  useEffect(() => {
    setCustomerQueriesPage(0);
    setCanLoadMoreQueries(true);
    if (selectedCustomer !== undefined) {
      getCustomerQueries([], 0);
    }
    setCustomerName(selectedCustomer ? selectedCustomer.CustomerName : '');

    if (firstCustomerUpdate.current) firstCustomerUpdate.current = false;
    else setFormIsDirty(true);
  }, [selectedCustomer]);

  const mobileVIew = useMediaQuery('(max-width: 500px)')

  return (
    <div className="manage-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs currPage={{ text: 'Create Query', link: '/query/create', type: 'create' }} />
        </div>
      </div>

      <Flex
          direction={{base: 'column', xl: 'row'}}
          align={{base: 'start', xl: 'start'}}
          justify={{base: 'around', xl: 'center'}}
      >
        <Box maw={1000} w={'100%'} mt={'sm'}>
          <QueryForm
              job={job}
              onCustomerChange={setSelectedCustomer}
              module={module}
              moduleID={moduleID}
              customerID={customerID}
              onClose={() => Helper.nextRouter(router.push, "/query/list")}
          />
        </Box>
        {
          !mobileVIew &&
            <Flex w={'100%'} justify={'center'}  mr={{xl: 'sm'}}>
              <QueryHistory
                  canLoadMoreQueries={canLoadMoreQueries}
                  customer={selectedCustomerName}
                  queries={selectedCustomerQueries}
                  querySearching={querySearching}
                  loadMoreQueries={loadMoreQueries}
              />
            </Flex>
        }
      </Flex>
    </div>
  );
}

export default CreateQuery;

export const Route = createFileRoute('/_authenticated/query/create')({ component: CreateQuery })
